/**
 * `sales` translations, for every locale.
 */
export const sales = {
  mn: {
      clientPage: {
        outstanding: 'Үлдэгдэл төлбөр',
        overdue: 'Хугацаа хэтэрсэн',
        revenue: 'Орлого (НӨАТ-гүй)',
        invoices: 'Нэхэмжлэх',
        openQuotes: 'Нээлттэй үнийн санал',
        lastDocument: 'Сүүлийн баримт',
        aging: 'Хугацааны задаргаа',
        current: 'Хугацаа болоогүй',
        days_1_30: '1–30 хоног',
        days_31_60: '31–60 хоног',
        days_61_90: '61–90 хоног',
        days_90_plus: '90-ээс дээш хоног',
        no_due_date: 'Төлөх хугацаагүй',
        noFigures: 'Танд харагдах гаргасан баримт алга',
        figuresHelp: 'Энэ харилцагчтай холбогдсон, танд харагдах гаргасан баримтуудыг тоолно. Дүнг валют тус бүрээр харуулж, хооронд нь хөрвүүлэхгүй. Орлого нь НӨАТ-аас өмнөх цэвэр дүн. Төлбөр нь цуцлагдсан нэхэмжлэх үлдэгдэл, орлогын аль алинд орохгүй.',
        exportCsv: 'CSV татах',
        exportFailed: '{{what}} татаж чадсангүй: {{error}}',
        documents: 'Баримтууд',
        openInSales: 'Борлуулалтын жагсаалтад нээх',
        notFound: 'Харилцагч олдсонгүй. Устгагдсан эсвэл холбоос буруу байж магадгүй.',
        back: 'Бүх харилцагч',
        openClientPage: 'Харилцагчийн хуудас',
        noDocuments: 'Энэ харилцагчид танд харагдах баримт алга',
        loadMore: 'Цааш ачаалах',
        sortBy: '{{column}}-ээр эрэмбэлэх',
      },
      docType: {
        'Sales Invoice': 'Нэхэмжлэх',
        Quotation: 'Үнийн санал',
        'Inventory expenditure order': 'Хадгаламжийн зарлагын баримт',
      },
      status: { Draft: 'Ноорог', Issued: 'Гаргасан', Void: 'Хүчингүй' },
      payment: { Unpaid: 'Төлөгдөөгүй', Paid: 'Төлөгдсөн', Partial: 'Хэсэгчлэн', Cancelled: 'Цуцалсан' },
      field: {
        createdBy: 'Үүсгэсэн',
        to: 'Хэнд',
        contact: 'Холбоо барих',
        position: 'Албан тушаал',
        contacts: 'Холбоо барих хүмүүс',
        primary: 'Үндсэн',
        addContact: 'Хүн нэмэх',
        noContacts: 'Холбоо барих хүн алга',
        organization: 'Байгууллагын нэр',
        registrationNo: 'Регистрийн дугаар',
        // Same column as `registrationNo`, labelled differently
        // for an individual (`models/reference.py::Client.kind`).
        registrationNoIndividual: 'Регистрийн дугаар (РД)',
        clientKind: 'Харилцагчийн төрөл',
        clientKindCompany: 'Байгууллага',
        clientKindIndividual: 'Хувь хүн',
        address: 'Хаяг',
        phone: 'Утас',
        email: 'И-мэйл',
        date: 'Огноо',
        dueDate: 'Төлөх хугацаа',
        currency: 'Валют',
        purchaser: 'Хүлээн авагч',
        otherTerms: 'Бусад нөхцөл',
        details: 'Дэлгэрэнгүй тэмдэглэл',
        detailsHint: 'ж: AGS - Res2D Inv',
        title: 'Гарчиг',
        type: 'Төрөл',
        noType: 'Дугаарын угтвар',
        requestDate: 'Хүсэлтийн огноо',
        total: 'Нийт дүн',
        preparedBy: 'Бэлтгэсэн',
        purpose: 'Зорилго',
        comment: 'Тайлбар',
        country: 'Улс',
        city: 'Хот / аймаг',
        startDate: 'Эхлэх огноо',
        endDate: 'Дуусах огноо',
        totalDays: 'Нийт хоног',
        amountReceived: 'Хүлээн авсан дүн',
        bankName: 'Банкны нэр',
        accountName: 'Дансны нэр',
        accountNumber: 'Дансны дугаар',
        department: 'Хэлтэс',
        hotelNorm: 'Буудлын норм',
        mealNorm: 'Хоолны норм',
        expenseType: 'Төрөл',
        paidBy: 'Төлсөн хэлбэр',
        rate: 'Ханш',
        activity: 'Үйл ажиллагаа',
        amount: 'Дүн',
        description: 'Тайлбар',
        income: 'Орлого',
        expense: 'Зарлага',
        period: 'Он, сар',
        product: 'Бүтээгдэхүүн',
        group: 'Бүлэг',
        subgroup: 'Дэд бүлэг / брэнд',
        licencingTool: 'Лицензийн хэрэгсэл',
        daily: 'Өдрийн',
        monthly: 'Сарын',
        quarterly: '3 сарын',
        semiannual: '6 сарын',
        annual: 'Жилийн',
        // ONE rate box. ⚠️ Still NOT `field.rate` (TripExpenses' compact column).
        // `{{unit}}` is USD, or KZT on a KZT document -- always known, since it
        // comes off the form's currency select.
        usdRate: 'Ханш (1 {{unit}}-д ногдох ₮)',
        usdRateHintMnt: 'Үнийн жагсаалтын (USD) үнийг сонгоход ₮ руу хөрвүүлнэ. Гараар оруулсан мөрөнд хэрэглэхгүй.',
        usdRateHintForeign: 'Нийт дүнгийн төгрөгөөрх дүнг баримт дээр хэвлэнэ. Хоосон бол хэвлэгдэхгүй.',
        usdRateInvalid: 'Эерэг тоо (6 хүртэлх орон бутархай) оруулна уу, эсвэл хоосон үлдээнэ үү.',
        kztUsdRate: 'Ханш (1 USD-д ногдох ₸)',
        kztUsdRateHint: 'Үнийн жагсаалтын (USD) үнийг сонгоход ₸ руу хөрвүүлнэ. Гараар оруулсан мөрөнд хэрэглэхгүй.',
        // Any ISO-4217 currency.
        currencyOther: 'Бусад…',
        currencyCode: 'Валютын код (ISO 4217)',
        currencyCodeApply: 'Хэрэглэх',
        currencyCodeInvalid: 'Гурван үсэг, жишээ нь EUR.',
        vatRegistrationNo: 'НӨАТ төлөгчийн дугаар',
        issuer: 'Нэхэмжлэгч компани',
        issuerAutomatic: 'Автомат (харилцагчийн эсвэл үндсэн компани)',
        issuerAutomaticNamed: 'Автомат — {{name}}',
        issuerWillPrint: 'Баримт дээр хэвлэгдэх: {{name}}',
        issuerPrinted: 'Гаргасан компани: {{name}}',
        // The bank box falls back to the org default company's account.
        bankFallback: '{{company}}-д {{currency}} данс алга — баримт дээр {{holder}}-ийн {{currency}} данс хэвлэгдэнэ.',
        bankNone: '{{company}}-д {{currency}} данс алга — баримт дээр банкны мэдээлэл хэвлэгдэхгүй.',
        // The document's own bank pick and signature toggle.
        bankAccount: 'Банкны данс',
        bankAutomatic: 'Автомат (харилцагчийн эсвэл компанийн данс)',
        // The document's own print language, independent of the app's.
        documentLanguage: 'Баримтын хэл',
        signAs: 'Гарын үсэг',
        signAsSelf: 'Өөрийн нэрээр',
        signAsAccountant: '{{name}} (нягтлан бодогч)',
        signAsNone: 'Гарын үсэг нь бүртгэлтэй нягтлан бодогч алга',
        newStyle: 'Шинэ загвар',
        newStyleHint: 'Шинэ загварын туршилтын PDF; баталгаажсан файл өөрчлөгдөхгүй',
        seequentContact: 'Seequent холбогдох хүн',
        fslProdCode: 'FSL бүтээгдэхүүний код',
        fslDealCode: 'FSL гэрээний код',
        fslUpdate: 'FSL шинэчлэл',
        note: 'Тэмдэглэл',
        active: 'Идэвхтэй',
        approval: 'Батлалтын төлөв',
        approvedAmount: 'Батлагдсан дүн',
        approvedBy: 'Баталсан',
        approved: 'Батлагдсан',
        adminApproved: 'Админ баталсан',
        rejectReason: 'Татгалзсан шалтгаан',
        name: 'Нэр',
        clientName: 'Нэр',
        accountManager: 'Хариуцсан менежер',
        noAccountManager: 'Хариуцагчгүй',
        accountManagerLocked: 'Зөвхөн одоогийн хариуцагч эсвэл админ өөрчилнө.',
        accountManagerUnknown: 'Ажлаас гарсан ажилтан',
        industry: 'Салбар',
        tags: 'Шошго',
        tagsHint: 'Таслалаар тусгаарлана.',
        clientNotes: 'Тэмдэглэл',
        nickname: 'Хоч нэр',
        clientNo: 'Харилцагчийн дугаар',
        no: 'Дугаар',
        status: 'Төлөв',
        payment: 'Төлбөр',
        paymentStatus: 'Төлбөрийн төлөв',
        paidDate: 'Төлсөн огноо',
        role: 'Албан тушаал',
        access: 'Хандах эрх',
        accessLevel: 'Хандах эрхийн түвшин',
        client: 'Харилцагч',
        defaultIssuerIdentity: 'Үндсэн гаргагч',
        defaultBankAccount: 'Үндсэн банкны данс',
        noDefault: '— Байхгүй —',
        chooseIdentityFirst: 'Эхлээд байгуулагч талыг сонгоно уу',
        bankIdentityMismatch: '(сонгосон байгуулагч талтай зөрчилтэй)',
      },
      line: {
        basePrice: 'Үндсэн үнэ',
        customsTaxPct: 'Гаалийн татвар %',
        marginPct: 'Ашгийн хувь %',
        markupInvalid: 'Үндсэн үнийг (аравтын 5 орон хүртэл) болон хувийг (аравтын 4 орон хүртэл) 0 эсвэл түүнээс их тоогоор оруулна уу.',
      },
      items: {
        no: '№',
        item: 'Утга',
        unit: 'Хэмжих нэгж',
        qty: 'Тоо',
        unitPrice: 'Нэгж үнэ',
        amount: 'Нийт үнэ',
        add: 'Мөр нэмэх',
        fromPriceList: 'Үнийн жагсаалтаас',
        empty: 'Мөр байхгүй байна',
        priceDecimals: 'Нэгж үнэ таслалаас хойш хамгийн ихдээ 5 оронтой байна',
        notNegative: '0 эсвэл түүнээс их байна',
        notANumber: 'Тоо оруулна уу',
      },
      totals: {
        // The MNT equivalent under the total.
        mntEquivalent: 'Төгрөгөөр (1 {{currency}} = {{rate}} ₮)',
        subtotal: 'Дүн',
        discount: 'Хөнгөлөлт',
        discountType: 'Хөнгөлөлтийн төрөл',
        discountOver100: 'Хувийн хөнгөлөлт 100-аас ихгүй байна.',
        vat: 'НӨАТ',
        rounding: 'Бүхэлчлэл',
        total: 'Нийт дүн',
      },
      discountType: { None: 'Байхгүй', Amount: 'Дүнгээр', Percentage: 'Хувиар' },
      issue: {
        confirmTitle: 'Баримтыг хадгалах уу?',
        confirmBody:
          'Хадгалсны дараа дугаар олгогдож, баримт өөрчлөгдөхгүй болно. Засах шаардлагатай бол шинэ хувилбар үүсгэнэ.',
        save: 'Хадгалах',
        saved: 'Хадгалагдлаа',
        draftKept: 'Ноорог хадгалагдсан боловч баримтыг хадгалж чадсангүй: {{error}}',
        sendEmail: 'Харилцагчид илгээх и-мэйл бэлтгэх',
        addressSite: 'Энэ баримт дээрх байгууллагын хаяг',
        addressDefault: 'үндсэн',
        site: { head_office: 'Төв оффис', branch: 'Салбар' },
        locked: 'Энэ баримт баталгаажсан тул засах боломжгүй.',
        lockedVoid: 'Энэ баримт хүчингүй болсон тул засах боломжгүй.',
        invoiceReadOnly: 'Борлуулалтын нэхэмжлэхийг зөвхөн нягтлан/СА/админ засварлана.',
        notYourDraft: 'Энэ төслийг зөвхөн үүсгэсэн хүн, санхүүгийн захирал, нягтлан бодогч эсвэл админ засварлана.',
        mailDraft: 'Харилцагчид илгээх и-мэйл',
        mailDraftTo: '{{to}} хаяг руу и-мэйл',
        mailOpenOutlook: 'Outlook-д нээх',
        mailLink: 'И-мэйлийн холбоос',
        mailNoAddress: 'Энэ баримтад харилцагчийн и-мэйл алга тул хүлээн авагчийн талбар хоосон байна.',
        mailBadAddress: '«{{typed}}» нь ашиглах боломжгүй и-мэйл хаяг тул хүлээн авагчийн талбар хоосон байна.',
        mailEmlSaved: 'Ноорог татагдлаа. Файлыг нээж, засаад илгээнэ үү.',
        mailPdfSaved: 'PDF татагдлаа. Илгээхээсээ өмнө и-мэйлд хавсаргана уу.',
        mailOpenFailed: 'И-мэйлийн ноорог татаж чадсангүй: {{reason}}',
        mailPdfFailed: 'PDF татаж чадсангүй: {{reason}}',
        mailDraftFailed: 'И-мэйл бэлтгэж чадсангүй: {{reason}}',
        mailLinkLoading: 'И-мэйл ачаалж байна.',
        mailLinkUnavailable: 'И-мэйл бэлтгэж чадсангүй.',
        mailLinkTooLong: 'Энэ и-мэйл холбоосонд багтахгүй урт байна. «Outlook-д нээх»-ийг ашиглана уу.',
      },
      void: {
        title: 'Баримтыг хүчингүй болгох',
        reasonLabel: 'Шалтгаан',
        confirm: 'Хүчингүй болгох',
      },
      paymentRecord: {
        title: 'Төлбөрийн түүх',
        balanceDue: 'Төлөгдөх үлдэгдэл',
        amountPaid: 'Төлсөн дүн',
        action: 'Төлбөр бүртгэх',
        dialogTitle: 'Төлбөр бүртгэх',
        amountLabel: 'Дүн',
        dateLabel: 'Огноо',
        noteLabel: 'Тэмдэглэл',
        submit: 'Бүртгэх',
        recorded: 'Төлбөр бүртгэгдлээ',
        amountInvalid: 'Дүн 0-ээс их байх ёстой',
        entryCleared: 'Дахин "Төлөгдөөгүй" болгосон',
        entryCancelled: 'Цуцалсан',
      },
      list: {
        clientDocuments: 'Баримтууд',
        empty: 'Баримт олдсонгүй',
        emptyClients: 'Харилцагч олдсонгүй',
        noChanges: 'Өөрчлөлт алга',
        partialIsDerived: '«Хэсэгчлэн» нь бүртгэсэн төлбөрөөс тооцогдоно: «Төлөгдөөгүй», «Төлөгдсөн» эсвэл «Цуцалсан»-ыг сонгоно уу.',
        filters: 'Шүүлтүүр',
        all: 'Бүгд',
        loadFailed: '{{title}} ачаалж чадсангүй',
        documentLoadFailed: 'Энэ баримтыг нээж чадсангүй',
        saveFailed: 'Хадгалж чадсангүй: {{reason}}',
        deleteFailed: 'Устгаж чадсангүй: {{reason}}',
        approveFailed: 'Батлж чадсангүй: {{reason}}',
        rejectFailed: 'Татгалзаж чадсангүй: {{reason}}',
        payFailed: 'Төлсөн гэж тэмдэглэж чадсангүй: {{reason}}',
        downloadFailed: 'PDF татаж чадсангүй: {{reason}}',
        loadedOf: '{{total}}-ийн {{count}} харуулав',
        loadingMore: 'Цааш ачаалж байна…',
        loadMoreRetry: 'Дахин ачаалах',
        mergeFailed: 'Нэгтгэж чадсангүй: {{reason}}',
        previewFailed: 'Урьдчилан харах зургийг гаргаж чадсангүй: {{reason}}',
        issueFailed: 'Баримтыг баталж гаргаж чадсангүй: {{reason}}',
        reviseFailed: 'Шинэ хувилбар үүсгэж чадсангүй: {{reason}}',
        convertFailed: 'Нэхэмжлэх болгон хөрвүүлж чадсангүй: {{reason}}',
        copyFailed: 'Хуулбар үүсгэж чадсангүй: {{reason}}',
        voidFailed: 'Хүчингүй болгож чадсангүй: {{reason}}',
        paymentFailed: 'Төлбөр бүртгэж чадсангүй: {{reason}}',
        pickHint: 'Дэлгэрэнгүйг харахын тулд харилцагч сонгоно уу.',
        discardConfirm: 'Хадгалаагүй өөрчлөлт байна. Хаях уу?',
        deleteClientConfirm: '“{{name}}” харилцагчийг устгах уу? Баримтад холбогдсон харилцагчийг устгах боломжгүй.',
        // Merge another client INTO the open one, which survives.
        mergeTitle: 'Өөр харилцагчийг энэ харилцагчтай нэгтгэх',
        mergeHint: 'Сонгосон харилцагчийн баримт, холбоо барих хүмүүс энд шилжиж, энэ харилцагчийн хоосон талбаруудыг нөхнө. Дараа нь тэр харилцагч устгагдана. Батлагдсан баримтын дугаар өөрчлөгдөхгүй.',
        mergePick: 'Харилцагч сонгох…',
        mergeSaveFirst: 'Нэгтгэхээс өмнө өөрчлөлтөө хадгалах эсвэл цуцална уу.',
        mergeAction: 'Нэгтгэх',
        mergeConfirm: '“{{loser}}”-г “{{survivor}}”-тэй нэгтгэх үү? “{{loser}}” устгагдана. Буцаах боломжгүй.',
        mergeDone: 'Харилцагчдыг нэгтгэлээ',
        mergeTakeRegNo: '“{{loser}}”-н {{regNo}} регистрийн дугаарыг мөн авах. Энэ дугаараар дугаарлагдсан баримтууд тухайн цувралаа үргэлжлүүлнэ.',
      },
      requestType: { Reimbursement: 'Нөхөн олголт', Purchase: 'Худалдан авалт' },
      requestStatus: { Pending: 'Хүлээгдэж буй', Approved: 'Батлагдсан', Sent: 'Илгээсэн', Rejected: 'Татгалзсан' },
      role: {
        Finance: 'Санхүү',
        Accountant: 'Нягтлан бодогч',
        'Chief finance officer': 'Санхүүгийн захирал',
        Dev: 'Хөгжүүлэгч',
      },
      requests: {
        new: 'Шинэ хүсэлт',
        empty: 'Хүсэлт алга байна',
        approve: 'Батлах',
        reject: 'Татгалзах',
        approved: 'Хүсэлт батлагдлаа',
        rejected: 'Хүсэлт татгалзагдлаа',
        alreadyApproved: 'Аль хэдийн батлагдсан.',
        alreadyRejected: 'Аль хэдийн татгалзсан.',
        items: 'Бараа',
        addRow: 'Мөр нэмэх',
        noItems: 'Бараа нэмнэ үү',
        needAmount: 'Дүнтэй дор хаяж нэг мөр нэмнэ үү.',
        details: 'Ерөнхий мэдээлэл',
        notes: 'Тэмдэглэл',
        selectPrompt: 'Жагсаалтаас хүсэлт сонгох, эсвэл шинээр үүсгэнэ үү.',
        pendingOnly: 'Зөвхөн хүлээгдэж буй',
        whose: 'Хэний хүсэлт',
      },
      trips: {
        new: 'Шинэ томилолт',
        empty: 'Томилолт алга байна',
        emptyFiltered: 'Энэ төлөвтэй томилолт алга',
        emptyMine: 'Таны томилолтоос тохирох нь алга',
        whose: 'Хэний томилолт',
        approve: 'Томилолт батлах',
        approved: 'Томилолт батлагдлаа',
        markPaid: 'Төлсөн гэж тэмдэглэх',
        paid: 'Томилолт төлөгдсөн гэж тэмдэглэгдлээ',
        already: 'Томилолт аль хэдийн батлагдсан.',
        expenses: 'Зардал',
        addExpense: 'Зардал нэмэх',
        noExpenses: 'Зардал алга байна',
        uploadReceipt: 'Баримт хавсаргах',
        receipt: 'Баримт',
        saveTripFirst: 'Зардал нэмэхийн тулд эхлээд томилолтоо хадгална уу.',
        currencyUnknown: 'Тодорхойгүй',
        details: 'Аяллын дэлгэрэнгүй',
        norms: 'Норм зардал',
        bankDetails: 'Дансны мэдээлэл',
        selectPrompt: 'Жагсаалтаас томилолт сонгох, эсвэл шинээр үүсгэнэ үү.',
      },
      activityFund: {
        new: 'Шинэ зардал',
        empty: 'Зардал алга байна',
        items: 'Арга хэмжээнүүд',
        addRow: 'Мөр нэмэх',
        noItems: 'Мөр байхгүй байна',
        thisMonth: 'Энэ сар',
        fundBalance: 'Сангийн үлдэгдэл',
        selectPrompt: 'Жагсаалтаас арга хэмжээ сонгох, эсвэл шинээр үүсгэнэ үү.',
        contributionsTitle: 'Сарын хандивын бүртгэл',
        extraIncomeTitle: 'Нэмэлт орлого',
        extraIncomeHint: 'Торгууль, хандив зэрэг сарын хандиваас гадуурх орлого. Идэвхийн оноонд тооцогдохгүй.',
        addExtraIncome: 'Орлого нэмэх',
        extraIncomePerson: 'Ажилтан',
        extraIncomeNoPerson: 'Хүнгүй',
        extraIncomeReason: 'Шалтгаан',
        extraIncomeRecordedBy: 'Бүртгэсэн',
        noExtraIncome: 'Нэмэлт орлого алга байна',
        extraIncomeInvalid: 'Огноо болон эерэг дүн оруулна уу.',
        expensesTitle: 'Зардлын жагсаалт',
        gridHint: 'Төлсөн сар дээр дарж тэмдэглэнэ.',
        settings: 'Тохиргоо',
        previousYear: 'Өмнөх жил',
        nextYear: 'Дараа жил',
        markPaid: 'Олгосон гэж тэмдэглэх',
        noContributors: 'Ажилтан алга байна',
        points: 'Оноо',
        offRoster: 'Бүртгэлээс гадуур',
        windowNotice: 'Энэ сарыг засах боломжгүй.',
        readOnlyNotice: 'Танд засах эрх алга.',
        notYoursNotice: 'Энэ зардлыг зөвхөн бүртгэсэн хүн эсвэл админ засна.',
        raisedBy: 'Бүртгэсэн',
        contributorsOnlyNotice:
          'Сарын хандивын бүртгэлийг санд хандив өгдөг хүмүүс харна.',
        saveChanges: 'Хадгалах',
        discardChanges: 'Өөрчлөлтийг цуцлах',
        unsavedChanges: '{{count}} хадгалагдаагүй өөрчлөлт',
        finishBeforeYearChange: 'Жил солихын өмнө өөрчлөлтөө хадгална уу эсвэл цуцална уу.',
        fundAmount: 'Хандив ба нэг онооны урамшуулал',
        fundAmountHint: 'Нэг дүн: шинээр бүртгэх сарын хандив, мөн өмнөх оны урамшууллыг олгохоор тэмдэглэсэн цалингийн тооцоонд нэг онооны олгох дүн. Бүртгэгдсэн сарууд дүнгээ хадгална; гаргаагүй цалингийн тооцоо шинэ дүнг ашиглана.',
        addPerson: 'Хүн нэмэх…',
        notSavedYet: 'Хадгалаагүй',
        notEligible: '{{name}} идэвхийн санд нэгдэх боломжгүй: зөвхөн бүтэн цагийн ажилтан болон цагаар цалинждаг гэрээт ажилтан нэгдэнэ',
        notEligibleNobody: 'Идэвхийн санд зөвхөн бүтэн цагийн ажилтан болон цагаар цалинждаг гэрээт ажилтан нэгдэнэ',
        setAmountFirst: 'Сангийн дүн 0 байна: сар тэмдэглэхийн өмнө дүнг тохируулна уу',
        leftOn: 'Гарсан: {{date}}',
      },
      // "Set the final total": one line's unit price reaches a target total.
      targetTotal: {
        action: 'Нийт дүн тохируулах…',
        title: 'Эцсийн нийт дүнг тохируулах',
        intro: 'Хүссэн нийт дүнгээ оруулаад, үнэ нь өөрчлөгдөх НЭГ мөрийг сонгоно уу. Хадгалах товч дарах хүртэл юу ч хадгалагдахгүй.',
        current: 'Одоогийн нийт дүн',
        targetLabel: 'Зорилтот нийт дүн',
        invalid: '0-ээс их, 2 хүртэлх бутархай оронтой дүн оруулна уу.',
        untitledLine: 'Нэргүй мөр',
        qty: 'тоо {{qty}}',
        unreachable: 'Энэ мөрийн аль ч үнэ яг {{target}} гаргахгүй. Хамгийн ойр дүнгүүд:',
        below: 'Доош',
        above: 'Дээш',
        belowMinimum: 'Энэ мөрийн үнийг 0 болговол ч нийт дүн {{target}}-с их байна.',
        aboveMaximum: 'Энэ мөрийн ямар ч үнэ {{target}}-д хүрэхгүй.',
        noEffect: 'Тоо хэмжээ 0 тул энэ мөрийн үнэ нийт дүнг өөрчлөхгүй.',
        done: '{{line}}-р мөрийн үнийг {{price}} болголоо — шалгаад хадгална уу.',
      },
      // See the English block for why counts are not `{{count}}`.
      // "Convert this DRAFT to USD": every line price and an amount
      // discount divided by the rate. Drafts only; nothing saves until Save.
      convertUsd: {
        action: 'Энэ ноорогийг USD руу хөрвүүлэх',
        warning: 'Мөр бүрийн үнэ болон дүнгээр өгсөн хөнгөлөлтийг {{rate}}-д хувааж, баримтын валютыг USD болгоно. Хадгалах хүртэл юу ч хадгалагдахгүй.',
        confirm: 'Хөрвүүлэх',
        done: '{{lines}} мөрийг USD руу хөрвүүллээ — шалгаад хадгална уу.',
      },
      reapply: {
        action: 'Ханш дахин тооцох',
        loading: 'Үнийн жагсаалт ачааллаж байна…',
        title: 'Валютын ханшийг дахин тооцох',
        warning:
          'Таны сонгосон мөр бүрийн нэгж үнийг үнийн жагсаалтын үнээс {{rate}} ханшаар {{currency}} руу хөрвүүлж ДАХИН БИЧНЭ. Сонгоогүй мөрүүд одоогийн үнээрээ хэвээр үлдэнэ.',
        currentPrice: 'Одоогийн',
        newPrice: 'Шинэ',
        untitledLine: 'Нэргүй мөр',
        unchanged: 'Аль хэдийн энэ ханшаар тооцогдсон.',
        selectedCount: 'Нийт {{total}} мөрөөс {{selected}} сонгосон',
        blockedCount: '{{blocked}} мөрийг дахин тооцох боломжгүй',
        confirm: 'Сонгосон мөрүүдэд тооцох',
        done: '{{applied}} мөрд ханшийг дахин тооцлоо',
        applied: '{{rate}} ханш {{at}}-д хэрэглэгдсэн',
        notRecorded: 'Хэрэглэсэн ханш: бүртгэгдээгүй',
        block: {
          'not-from-price-list': 'Гараар бичсэн — хөрвүүлэх үнийн жагсаалтын үнэ байхгүй.',
          'item-not-found': 'Үнийн жагсаалтын холбогдох бараа устсан байна.',
          // Re-apply converts USD list prices only.
          'item-currency': 'Энэ барааны үнэ USD-ээр биш тул ханшийг дахин хэрэглэх боломжгүй.',
          'unit-not-a-tier':
            'Хэмжих нэгж нь үнийн жагсаалтын түвшинг заагаагүй тул аль үнээс авсан нь тодорхойгүй.',
          'no-price-for-tier': 'Үнийн жагсаалтад энэ түвшний үнэ алга.',
        },
      },
      // Download asks whether the signature goes on the PDF.
      pdfSignature: {
        title: 'PDF татах',
        body: 'Гарын үсгийг PDF дээр оруулах уу?',
        include: 'Гарын үсэгтэй',
        omit: 'Гарын үсэггүй',
        notSigner: 'Энэ баримт гарын үсэггүй гарсан. Зөвхөн гарын үсэг зурсан хүн өөрийнхөө гарын үсгийг нэмж чадна.',
        addToContinue: 'Танд гарын үсэг байхгүй байна. Гарын үсгээ нэмбэл татаж авалт үргэлжилнэ.',
        stillNone: 'Гарын үсэг нэмэгдээгүй тул файл татагдсангүй.',
      },
      lineage: {
        converted: '{{no}}-с хөрвүүлсэн',
        revised: '{{no}}-с шинэчлэн зассан',
        copied: '{{no}}-с хуулсан',
        unknown: '{{no}}-с үүссэн',
        untitled: 'өмнөх ноорог',
        copyDone: 'Хуулбар үүслээ',
        copyAction: 'Хуулбар үүсгэх',
        copyNotLinked: 'Энэ хуулбар нь эх баримттайгаа холбогдоогүй байна.',
        copySaveFirst: 'Хуулбар үүсгэхийн өмнө өөрчлөлтөө хадгална уу.',
        copyHint: 'Үүнээс эхэлж шинэ, тусдаа баримт үүсгэнэ. Энэ баримт өөрчлөгдөхгүй.',
        reviseAction: 'Шинэ хувилбар',
        reviseHint: 'Энэ баримтыг орлох шинэ хувилбар үүсгэнэ. Шинэ хувилбарыг хадгалахад энэ баримт хүчингүй болно.',
        reviseDone: 'Шинэ хувилбарын ноорог үүслээ',
        reviseSuperseded: 'Энэ хувилбарыг шинэ хувилбар орлосон. Сүүлийн хувилбарыг нээж засна уу.',
        supersededShort: 'Орлогдсон',
        versionsTitle: 'Хувилбарууд',
        quotationReplaced: 'Энэ үнийн саналаас шинэчилсэн эсвэл нэхэмжлэх аль хэдийн үүссэн. Дахин хийхийн өмнө түүнийг хүчингүй болгох эсвэл устгана уу.',
      },
      // `draft` is for a replacement with no number yet -- never invent one.
      replaced: {
        numbered: '#{{no}} баримтаар солигдсон',
        draft: 'Ноорог баримтаар солигдсон',
      },
      priceList: {
        new: 'Шинэ бараа',
        edit: 'Бараа засах',
        productRequired: 'Бүтээгдэхүүний нэрийг оруулна уу.',
        empty: 'Үнийн жагсаалт хоосон байна',
        selectPrompt: 'Жагсаалтаас бараа сонгох, эсвэл шинээр үүсгэнэ үү.',
        sectionProduct: 'Бүтээгдэхүүн ба ангилал',
        sectionPricing: 'Үнэ',
        sectionCodes: 'Код ба тэмдэглэл',
        pickOrType: 'Сонгох эсвэл шинээр бичих',
        percentLabel: 'Жилийн %',
        percentNeedsAnnual: 'Хувиар тооцохын тулд жилийн үнэ оруулна уу.',
        lineCount: 'Мөр: {{count}}',
        // The grouped table's chevrons, and the picker's tunnel filters.
        expandAll: 'Бүгдийг дэлгэх',
        collapseAll: 'Бүгдийг хураах',
        expand: '{{name}}-г дэлгэх',
        collapse: '{{name}}-г хураах',
        // The picker's custom tax % and margin %.
        customTaxPct: 'Гаалийн татвар %',
        marginPct: 'Ашгийн хувь %',
        markupInvalid: 'Хувийг 0 эсвэл түүнээс их тоогоор оруулна уу.',
        unnamed: '(байхгүй)',
        filterAny: 'Бүгд',
        addUnder: '“{{product}}”-д мөр нэмэх',
        rateApplied: 'Үнийн жагсаалтын үнэ (USD) 1 USD = {{rate}} ₮ ханшаар {{currency}} руу хөрвүүлэгдэнэ.',
        rateInvalid: 'Үнийн жагсаалтын үнийг (USD) энэ баримтад татахын тулд ханшийг (1 USD-д ногдох ₮) зөв оруулна уу.',
        rateKztNeeded: 'Үнийн жагсаалтын үнийг (USD) энэ баримтад татахын тулд ханшийг (1 USD-д ногдох ₸) зөв оруулна уу.',
        rateAppliedKzt: 'Үнийн жагсаалтын үнэ (USD) 1 USD = {{rate}} ₸ ханшаар тэнге рүү хөрвүүлэгдэнэ.',
        // A non-USD item the document's one rate cannot convert.
        itemCurrencyRefused: 'Үнэ нь {{item}}-ээр — {{currency}} баримтад татах боломжгүй.',
        rateChange: 'Ханш өөрчлөх',
        rateChangeApply: 'Хэрэглэх',
        rateAskInline: 'Ханш тодорхойгүй тул доорх үнийг жагсаалтын валютаар харуулж байна. Үнийг дарахад ханш асууна.',
        askRate: '1 {{from}} =',
        askRateAdd: 'Нэмэх',
        semiannualHint: 'Гараар оруулна — жилийн үнээс тооцоогдохгүй.',
      },
  },
  en: {
      clientPage: {
        outstanding: 'Outstanding',
        overdue: 'Overdue',
        revenue: 'Revenue (excl. VAT)',
        invoices: 'Invoices',
        openQuotes: 'Open quotations',
        lastDocument: 'Last document',
        aging: 'Aging',
        current: 'Not yet due',
        days_1_30: '1–30 days',
        days_31_60: '31–60 days',
        days_61_90: '61–90 days',
        days_90_plus: 'Over 90 days',
        no_due_date: 'No due date',
        noFigures: 'No issued documents you can see',
        figuresHelp: 'Counts the issued documents linked to this client that you can see. Amounts are shown per currency and never converted. Revenue is the net amount before VAT. An invoice whose payment was cancelled counts in neither outstanding nor revenue.',
        exportCsv: 'Export CSV',
        exportFailed: 'Could not export {{what}}: {{error}}',
        documents: 'Documents',
        openInSales: 'Open in sales list',
        notFound: 'Client not found. It may have been deleted or merged, or the link is wrong.',
        back: 'All clients',
        openClientPage: 'Client page',
        noDocuments: 'No documents for this client that you can see',
        loadMore: 'Load more',
        sortBy: 'Sort by {{column}}',
      },
      docType: {
        'Sales Invoice': 'Sales invoice',
        Quotation: 'Quotation',
        'Inventory expenditure order': 'Inventory expenditure order',
      },
      status: { Draft: 'Draft', Issued: 'Issued', Void: 'Void' },
      payment: { Unpaid: 'Unpaid', Paid: 'Paid', Partial: 'Partial', Cancelled: 'Cancelled' },
      field: {
        createdBy: 'Created by',
        to: 'To',
        contact: 'Contact',
        position: 'Position',
        contacts: 'Contacts',
        primary: 'Primary',
        addContact: 'Add contact',
        noContacts: 'No contacts yet',
        organization: 'Organization',
        registrationNo: 'Registration no.',
        registrationNoIndividual: 'Personal register number (РД)',
        clientKind: 'Client kind',
        clientKindCompany: 'Company',
        clientKindIndividual: 'Individual',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        date: 'Date',
        dueDate: 'Due date',
        currency: 'Currency',
        purchaser: 'Purchaser',
        otherTerms: 'Other terms',
        details: 'Details / reference',
        detailsHint: 'e.g. AGS - Res2D Inv',
        title: 'Title',
        type: 'Type',
        noType: 'Number prefix',
        requestDate: 'Request date',
        total: 'Total',
        preparedBy: 'Prepared by',
        purpose: 'Purpose',
        comment: 'Comment',
        country: 'Country',
        city: 'City / province',
        startDate: 'Start date',
        endDate: 'End date',
        totalDays: 'Total days',
        amountReceived: 'Amount received',
        bankName: 'Bank name',
        accountName: 'Account name',
        accountNumber: 'Account number',
        department: 'Department',
        hotelNorm: 'Hotel norm',
        mealNorm: 'Meal norm',
        expenseType: 'Type',
        paidBy: 'Paid by',
        rate: 'Rate',
        activity: 'Activity',
        amount: 'Amount',
        description: 'Description',
        income: 'Income',
        expense: 'Expense',
        period: 'Period',
        product: 'Product',
        group: 'Group',
        subgroup: 'Subgroup / brand',
        // The DISPLAYED English is `Licensing tool` --
        // the `-ing` form is spelt with an `s` in British and American English
        // alike. The key, the `licencing_tool` column, the Pydantic field and
        // the TypeScript property keep the misspelling deliberately: it is the
        // SharePoint field name the importer still reads by
        // (`scripts/import_sharepoint.py:1058`, `row.get("Licencing tool")`),
        // so renaming them would cost a migration and still not fix the
        // source. Fix what a reader READS, keep what a reader CITES.
        licencingTool: 'Licensing tool',
        daily: 'Daily',
        monthly: 'Monthly',
        quarterly: '3-monthly',
        semiannual: '6-monthly',
        annual: 'Annual',
        // ONE rate box. ⚠️ Still NOT `field.rate` (TripExpenses' compact column).
        // `{{unit}}` is USD, or KZT on a KZT document -- always known, since it
        // comes off the form's currency select.
        usdRate: 'Rate (₮ per 1 {{unit}})',
        usdRateHintMnt: 'Converts price-list prices (USD) into ₮ when you pick them. Hand-typed lines are not converted.',
        usdRateHintForeign: 'Prints the total in ₮ under the total. Leave blank to print no ₮ figure.',
        usdRateInvalid: 'Enter a positive number (up to 6 decimals), or leave it blank.',
        kztUsdRate: 'Rate (₸ per 1 USD)',
        kztUsdRateHint: 'Converts price-list prices (USD) into ₸ when you pick them. Hand-typed lines are not converted.',
        // Any ISO-4217 currency.
        currencyOther: 'Other…',
        currencyCode: 'Currency code (ISO 4217)',
        currencyCodeApply: 'Use',
        currencyCodeInvalid: 'Three letters, e.g. EUR.',
        vatRegistrationNo: 'VAT registration no.',
        issuer: 'Issuing company',
        issuerAutomatic: 'Automatic (client or company default)',
        issuerAutomaticNamed: 'Automatic — {{name}}',
        issuerWillPrint: 'Prints as: {{name}}',
        issuerPrinted: 'Issued as: {{name}}',
        // The bank box falls back to the org default company's account.
        bankFallback: "{{company}} has no {{currency}} account — the invoice will show {{holder}}'s {{currency}} account.",
        bankNone: '{{company}} has no {{currency}} account — no bank details will print.',
        // The document's own bank pick and signature toggle.
        bankAccount: 'Bank account',
        bankAutomatic: "Automatic (the client's or the company's account)",
        // The document's own print language, independent of the app's.
        documentLanguage: 'Document language',
        signAs: 'Sign as',
        signAsSelf: 'Myself',
        signAsAccountant: '{{name}} (accountant)',
        signAsNone: 'No accountant has a signature on file',
        newStyle: 'New style',
        newStyleHint: 'A trial PDF in the new style; the issued file is not changed',
        seequentContact: 'Seequent contact',
        fslProdCode: 'FSL product code',
        fslDealCode: 'FSL deal code',
        fslUpdate: 'FSL update',
        note: 'Note',
        active: 'Active',
        approval: 'Approval',
        approvedAmount: 'Approved amount',
        approvedBy: 'Approved by',
        approved: 'Approved',
        adminApproved: 'Admin approved',
        rejectReason: 'Reject reason',
        name: 'Name',
        clientName: 'Name',
        accountManager: 'Account manager',
        noAccountManager: 'Unassigned',
        accountManagerLocked: 'Only the current account manager or an administrator can change this.',
        accountManagerUnknown: 'Former staff member',
        industry: 'Industry',
        tags: 'Tags',
        tagsHint: 'Separate with commas.',
        clientNotes: 'Notes',
        nickname: 'Nickname',
        clientNo: 'Client no.',
        no: 'No',
        status: 'Status',
        payment: 'Payment',
        paymentStatus: 'Payment status',
        paidDate: 'Paid date',
        role: 'Role',
        access: 'Access',
        accessLevel: 'Access level',
        client: 'Client',
        defaultIssuerIdentity: 'Default issuer',
        defaultBankAccount: 'Default bank account',
        noDefault: '— None —',
        chooseIdentityFirst: 'Choose an issuer first',
        bankIdentityMismatch: '(mismatched with the chosen issuer)',
      },
      line: {
        basePrice: 'Base price',
        customsTaxPct: 'Customs tax %',
        marginPct: 'Margin %',
        markupInvalid: 'Enter the base price (up to 5 decimals) and percentages (up to 4 decimals) as numbers, 0 or more.',
      },
      items: {
        no: '#',
        item: 'Description',
        unit: 'Unit',
        qty: 'Qty',
        unitPrice: 'Unit price',
        amount: 'Amount',
        add: 'Add line',
        fromPriceList: 'From price list',
        empty: 'No lines yet',
        priceDecimals: 'A unit price takes at most 5 decimals',
        notNegative: 'Must be 0 or more',
        notANumber: 'Enter a number',
      },
      totals: {
        // The MNT equivalent under the total.
        mntEquivalent: 'Total in MNT (1 {{currency}} = {{rate}} ₮)',
        subtotal: 'Subtotal',
        discount: 'Discount',
        discountType: 'Discount type',
        discountOver100: 'A percentage discount cannot be more than 100.',
        vat: 'VAT',
        rounding: 'Rounding',
        total: 'Total',
      },
      discountType: { None: 'None', Amount: 'Amount', Percentage: 'Percentage' },
      issue: {
        confirmTitle: 'Save this document?',
        confirmBody:
          'Saving assigns the document number and freezes the record. It cannot be edited afterwards -- changes require a new revision.',
        save: 'Save',
        saved: 'Saved',
        draftKept: 'Kept as a draft, but it could not be saved as a document: {{error}}',
        sendEmail: 'Prepare an email to the client',
        addressSite: 'Company address on this document',
        addressDefault: 'default',
        site: { head_office: 'Head office', branch: 'Branch' },
        locked: 'This document has been issued and can no longer be edited.',
        lockedVoid: 'This document is void and can no longer be edited.',
        invoiceReadOnly: 'Sales Invoices are editable only by an accountant, CFO or admin.',
        notYourDraft: 'This draft can be changed only by its creator, the CFO, the accountant or an admin.',
        mailDraft: 'Mail to the client',
        mailDraftTo: 'Mail to {{to}}',
        mailOpenOutlook: 'Open in Outlook',
        mailLink: 'Mail link',
        mailNoAddress: 'This document has no client email, so the To field is blank.',
        mailBadAddress: '"{{typed}}" is not a usable email address, so the To field is blank.',
        mailEmlSaved: 'Draft downloaded. Open the file to edit and send it.',
        mailPdfSaved: 'PDF downloaded. Attach it to the mail before sending.',
        mailOpenFailed: 'Could not download the mail draft: {{reason}}',
        mailPdfFailed: 'Could not download the PDF: {{reason}}',
        mailDraftFailed: 'Could not prepare the mail: {{reason}}',
        mailLinkLoading: 'The mail is still loading.',
        mailLinkUnavailable: 'The mail could not be prepared.',
        mailLinkTooLong: 'This mail is too long for a mail link. Use Open in Outlook.',
      },
      void: {
        title: 'Void this document',
        reasonLabel: 'Reason',
        confirm: 'Void document',
      },
      paymentRecord: {
        title: 'Payments',
        balanceDue: 'Balance due',
        amountPaid: 'Amount paid',
        action: 'Record payment',
        dialogTitle: 'Record a payment',
        amountLabel: 'Amount',
        dateLabel: 'Date',
        noteLabel: 'Note',
        submit: 'Record payment',
        recorded: 'Payment recorded',
        amountInvalid: 'Amount must be greater than zero',
        entryCleared: 'Marked unpaid',
        entryCancelled: 'Cancelled',
      },
      list: {
        clientDocuments: 'Documents',
        empty: 'No documents found',
        emptyClients: 'No clients found',
        noChanges: 'Nothing has changed yet',
        partialIsDerived: 'Partial comes from recorded payments: pick Unpaid, Paid or Cancelled.',
        filters: 'Filters',
        all: 'All',
        loadFailed: 'Could not load {{title}}',
        documentLoadFailed: 'This document could not be opened',
        saveFailed: 'Could not save: {{reason}}',
        deleteFailed: 'Could not delete: {{reason}}',
        approveFailed: 'Could not approve: {{reason}}',
        rejectFailed: 'Could not reject: {{reason}}',
        payFailed: 'Could not mark as paid: {{reason}}',
        downloadFailed: 'Could not download the PDF: {{reason}}',
        loadedOf: '{{count}} of {{total}} shown',
        loadingMore: 'Loading more…',
        loadMoreRetry: 'Retry loading more',
        mergeFailed: 'Could not merge: {{reason}}',
        previewFailed: 'Could not build the preview: {{reason}}',
        issueFailed: 'Could not issue the document: {{reason}}',
        reviseFailed: 'Could not start a new version: {{reason}}',
        convertFailed: 'Could not convert to an invoice: {{reason}}',
        copyFailed: 'Could not make a copy: {{reason}}',
        voidFailed: 'Could not void the document: {{reason}}',
        paymentFailed: 'Could not record the payment: {{reason}}',
        pickHint: 'Select a client to view its details.',
        discardConfirm: 'You have unsaved changes. Discard them?',
        deleteClientConfirm: 'Delete the client “{{name}}”? A client that any document refers to cannot be deleted.',
        // Merge another client INTO the open one, which survives.
        mergeTitle: 'Merge another client into this one',
        mergeHint: 'The chosen client’s documents and contacts move here, and its details fill this client’s empty fields. Then it is deleted. Issued documents keep their numbers.',
        mergePick: 'Choose a client…',
        mergeSaveFirst: 'Save or cancel your changes before merging.',
        mergeAction: 'Merge',
        mergeConfirm: 'Merge “{{loser}}” into “{{survivor}}”? “{{loser}}” will be deleted. This cannot be undone.',
        mergeDone: 'Clients merged',
        mergeTakeRegNo: 'Also take registration number {{regNo}} from {{loser}}. Documents numbered under it will continue that series.',
      },
      requestType: { Reimbursement: 'Reimbursement', Purchase: 'Purchase' },
      requestStatus: { Pending: 'Pending', Approved: 'Approved', Sent: 'Sent', Rejected: 'Rejected' },
      role: {
        Finance: 'Finance',
        Accountant: 'Accountant',
        'Chief finance officer': 'Chief finance officer',
        Dev: 'Dev',
      },
      requests: {
        new: 'New request',
        empty: 'No requests yet',
        approve: 'Approve',
        reject: 'Reject',
        approved: 'Request approved',
        rejected: 'Request rejected',
        alreadyApproved: 'Already approved.',
        alreadyRejected: 'Already rejected.',
        items: 'Items',
        addRow: 'Add row',
        noItems: 'No items yet',
        needAmount: 'Add at least one item with an amount.',
        details: 'Details',
        notes: 'Notes',
        selectPrompt: 'Select a request from the list, or create a new one.',
        pendingOnly: 'Pending only',
        whose: 'Whose requests',
      },
      trips: {
        new: 'New trip',
        empty: 'No trips yet',
        emptyFiltered: 'No trips with this status',
        emptyMine: 'None of your trips match',
        whose: 'Whose trips',
        approve: 'Approve trip',
        approved: 'Trip approved',
        markPaid: 'Mark paid',
        paid: 'Trip marked paid',
        already: 'Trip already approved.',
        expenses: 'Expenses',
        addExpense: 'Add expense',
        noExpenses: 'No expenses yet',
        uploadReceipt: 'Upload receipt',
        receipt: 'Receipt',
        saveTripFirst: 'Save the trip first to add expenses.',
        currencyUnknown: 'Not stated',
        details: 'Trip details',
        norms: 'Cost norms',
        bankDetails: 'Bank details',
        selectPrompt: 'Select a trip from the list, or create a new one.',
      },
      activityFund: {
        new: 'New expense',
        empty: 'No expenses yet',
        items: 'Activities',
        addRow: 'Add row',
        noItems: 'No rows yet',
        thisMonth: 'This month',
        fundBalance: 'Fund balance',
        selectPrompt: 'Select an activity from the list, or create a new one.',
        contributionsTitle: 'Monthly contributions',
        extraIncomeTitle: 'Extra income',
        extraIncomeHint: 'Money paid into the fund outside the monthly contributions, such as fines or donations. It earns no activity points.',
        addExtraIncome: 'Add income',
        extraIncomePerson: 'Person',
        extraIncomeNoPerson: 'No person',
        extraIncomeReason: 'Reason',
        extraIncomeRecordedBy: 'Recorded by',
        noExtraIncome: 'No extra income yet',
        extraIncomeInvalid: 'Enter a date and an amount above zero.',
        expensesTitle: 'Expenses',
        gridHint: 'Click a month to mark it paid.',
        settings: 'Settings',
        previousYear: 'Previous year',
        nextYear: 'Next year',
        markPaid: 'Mark as paid',
        noContributors: 'No staff to show',
        points: 'Points',
        offRoster: 'Off roster',
        windowNotice: 'This month cannot be edited.',
        readOnlyNotice: 'You do not have permission to edit this.',
        notYoursNotice: 'Only the person who raised this expense, or an admin, can change it.',
        raisedBy: 'Raised by',
        contributorsOnlyNotice:
          'The monthly contribution list is visible to the people who pay into the fund.',
        saveChanges: 'Save',
        discardChanges: 'Discard',
        unsavedChanges: '{{count}} unsaved change(s)',
        finishBeforeYearChange: 'Save or discard your changes before switching year.',
        fundAmount: 'Contribution and bonus per point',
        fundAmountHint: 'One amount: what a newly recorded month asks for, and what each activity point pays in the payroll run marked to pay last year\'s fund. Months already recorded keep their amounts; payroll runs not yet issued use the new amount.',
        addPerson: 'Add person…',
        notSavedYet: 'Not saved',
        notEligible: '{{name}} cannot join the activity fund: only full-time staff and contractors paid hourly can',
        notEligibleNobody: 'Only full-time staff and contractors paid hourly can join the activity fund',
        setAmountFirst: 'The fund amount is 0: set an amount before ticking a month',
        leftOn: 'Left {{date}}',
      },
      // "Set the final total": one line's unit price reaches a target total.
      targetTotal: {
        action: 'Set total…',
        title: 'Set the final total',
        intro: 'Type the total you want, then pick ONE line whose unit price changes to reach it. Nothing is saved until you press Save.',
        current: 'Current total',
        targetLabel: 'Target total',
        invalid: 'Enter an amount above 0 with at most 2 decimals.',
        untitledLine: 'Untitled line',
        qty: 'qty {{qty}}',
        unreachable: 'No price on this line gives exactly {{target}}. The nearest totals:',
        below: 'Below',
        above: 'Above',
        belowMinimum: 'Even a price of 0 on this line leaves the total above {{target}}.',
        aboveMaximum: 'No price on this line reaches {{target}}.',
        noEffect: 'The quantity is 0, so this line’s price cannot change the total.',
        done: 'Line {{line}} price set to {{price}} — review it, then save.',
      },
      // Re-applying the document's exchange rate to lines that
      // are already on it.
      //
      // The rate arithmetic is client-side (`convertedUnitPrice`), so every
      // interpolation below is known SYNCHRONOUSLY -- off the form the user is
      // looking at, never off a request in flight. None of these sentences can
      // render with an empty `()`.
      //
      // Counts are interpolated as `{{selected}}` / `{{total}}` / `{{blocked}}`
      // and deliberately NOT as `{{count}}`: i18next treats `count` as a plural
      // trigger and looks for `_one`/`_other` suffixes, which
      // `i18n/keys.test.ts` cannot resolve from a statically-written call site
      // (see `priceList.lineCount` for the same decision).
      // "Convert this DRAFT to USD": every line price and an amount
      // discount divided by the rate. Drafts only; nothing saves until Save.
      convertUsd: {
        action: 'Convert this draft to USD',
        warning: 'Every line price and an amount discount will be divided by {{rate}}, and the document currency set to USD. Nothing is saved until you press Save.',
        confirm: 'Convert',
        done: '{{lines}} lines converted to USD — review them, then save.',
      },
      reapply: {
        action: 'Re-apply rate',
        loading: 'Loading the price list…',
        title: 'Re-apply the exchange rate',
        // ⛔ Part of the feature, not polish: the warning must say that prices get REWRITTEN before the user picks.
        warning:
          'This rewrites the unit price of every line you tick, converting its price-list price at {{rate}} into {{currency}}. Lines you leave unticked keep the price they have now.',
        currentPrice: 'Current',
        newPrice: 'New',
        untitledLine: 'Untitled line',
        unchanged: 'Already at this rate.',
        selectedCount: '{{selected}} of {{total}} lines selected',
        blockedCount: '{{blocked}} cannot be re-applied',
        confirm: 'Re-apply to selected',
        done: 'Re-applied the rate to {{applied}} lines',
        // Per-line provenance. ⛔ `notRecorded` means UNKNOWN, never "not
        // converted" -- the rate is stored per line from the pick or the
        // re-apply; older, hand-typed and hand-edited lines have no record.
        applied: 'Rate {{rate}} applied {{at}}',
        notRecorded: 'Rate used: not recorded',
        // Reached via a template literal, `t(`reapply.block.${row.block}`)`.
        // Each refusal is its own sentence: a shared "unavailable" would hide a
        // deleted price-list item inside the hand-typed case.
        block: {
          'not-from-price-list': 'Typed by hand — there is no price-list price to convert.',
          'item-not-found': 'Its price-list item no longer exists.',
          // Re-apply converts USD list prices only.
          'item-currency': 'This item is not priced in USD, so the rate does not apply to it.',
          'unit-not-a-tier':
            'Its unit does not name a price-list tier, so which of the five prices it came from is unknown.',
          'no-price-for-tier': 'The price list has no price for this tier.',
        },
      },
      // Download asks whether the signature goes on the PDF.
      pdfSignature: {
        title: 'Download PDF',
        body: 'Put the signature on the PDF?',
        include: 'With signature',
        omit: 'Without signature',
        notSigner: 'This document was issued without a signature. Only its signer can add theirs.',
        addToContinue: 'You have no signature on file. Add one and the download continues.',
        stillNone: 'No signature was added, so nothing was downloaded.',
      },
      // What a `copy_of_id` link says, where it can be established.
      // ⛔ `unknown` is the neutral form and is NOT a missing translation: it is
      // what renders when the server did not record WHICH relation this is.
      lineage: {
        converted: 'Converted from {{no}}',
        revised: 'Revised from {{no}}',
        copied: 'Copied from {{no}}',
        unknown: 'From {{no}}',
        untitled: 'an earlier draft',
        copyDone: 'Copy created',
        copyAction: 'Copy',
        // Stated on the copy itself, because the create route cannot store the
        // link -- so the new draft genuinely has no provenance and
        // must not imply otherwise.
        copyNotLinked: 'This copy is not linked back to the document it came from.',
        copySaveFirst: 'Save your changes before copying.',
        copyHint: 'Start a new, separate document from this one. This one is not changed.',
        reviseAction: 'New version',
        reviseHint: 'Make a new version that replaces this one. When the new version is saved, this one is voided as superseded.',
        reviseDone: 'New version draft created',
        reviseSuperseded: 'This version is already superseded. Open the latest version to revise it.',
        supersededShort: 'Superseded',
        versionsTitle: 'Versions',
        quotationReplaced: 'This quotation already has a live revision or invoice. Void or delete it first.',
      },
      // `draft` is for a replacement with no number yet -- never invent one.
      replaced: {
        numbered: 'Replaced by #{{no}}',
        draft: 'Replaced by a draft',
      },
      priceList: {
        new: 'New item',
        edit: 'Edit item',
        productRequired: 'Enter a product name.',
        empty: 'No price-list items yet',
        selectPrompt: 'Select an item from the list, or create a new one.',
        sectionProduct: 'Product and classification',
        sectionPricing: 'Pricing',
        sectionCodes: 'Codes and note',
        pickOrType: 'Pick one, or type a new one',
        percentLabel: '% of annual',
        // A percentage of nothing is NOT APPLICABLE, not 0%.
        percentNeedsAnnual: 'Set an annual price to enter this as a percentage.',
        // The count beside a product heading, and the label on the
        // add-under-this-product button.
        //
        // ⛔ Phrased WITHOUT a plural, deliberately. i18next's `_one`/`_other`
        // suffixes cannot be used at a statically-written call site here:
        // `i18n/keys.test.ts` resolves the literal key path and knows nothing
        // about plural suffixes, so `t('priceList.lineCount')` against
        // `lineCount_one`/`lineCount_other` fails the sweep. `Lines: 3` is
        // grammatical at every count in all three languages and needs none.
        lineCount: 'Lines: {{count}}',
        // The grouped table's chevrons, and the picker's tunnel filters.
        expandAll: 'Expand all',
        collapseAll: 'Collapse all',
        expand: 'Expand {{name}}',
        collapse: 'Collapse {{name}}',
        // The picker's custom tax % and margin %.
        customTaxPct: 'Custom tax %',
        marginPct: 'Margin %',
        markupInvalid: 'Enter each percentage as a number, 0 or more.',
        unnamed: '(none)',
        filterAny: 'Any',
        addUnder: 'Add a line under “{{product}}”',
        // Both interpolations are known SYNCHRONOUSLY -- they
        // come off the form the user is looking at, not off a request in
        // flight -- so this sentence cannot render 'converted at () into
        // ()'. The picker renders it only in the `rate` state, never in
        // `none` or `invalid`.
        rateApplied: 'Price-list prices (USD) below are converted at {{rate}} ₮ per 1 USD into {{currency}}.',
        rateInvalid: 'Enter the rate (₮ per 1 USD) to import price-list prices (USD) onto this document.',
        rateKztNeeded: 'Enter the rate (₸ per 1 USD) to import price-list prices (USD) onto this document.',
        rateAppliedKzt: 'Price-list prices (USD) below are converted at {{rate}} ₸ per 1 USD into KZT.',
        // A non-USD item the document's one rate cannot convert.
        itemCurrencyRefused: 'Priced in {{item}} — cannot be added to a {{currency}} document.',
        rateChange: 'Change rate',
        rateChangeApply: 'Apply',
        rateAskInline: 'No usable rate on this document yet, so prices below are shown in the list\'s own currency. Click one and you will be asked for the rate.',
        askRate: '1 {{from}} =',
        askRateAdd: 'Add',
        // A fact about the COLUMN, not about the open row.
        semiannualHint: 'Entered by hand — not derived from the annual price.',
      },
  },
  ru: {
      clientPage: {
        outstanding: 'Задолженность',
        overdue: 'Просрочено',
        revenue: 'Выручка (без НДС)',
        invoices: 'Счета',
        openQuotes: 'Открытые предложения',
        lastDocument: 'Последний документ',
        aging: 'Сроки задолженности',
        current: 'Срок не наступил',
        days_1_30: '1–30 дней',
        days_31_60: '31–60 дней',
        days_61_90: '61–90 дней',
        days_90_plus: 'Более 90 дней',
        no_due_date: 'Без срока оплаты',
        noFigures: 'Нет выданных документов, доступных вам',
        figuresHelp: 'Учитываются выданные документы этого клиента, доступные вам. Суммы показаны по каждой валюте и не пересчитываются. Выручка — сумма без НДС. Счёт с отменённой оплатой не входит ни в задолженность, ни в выручку.',
        exportCsv: 'Экспорт CSV',
        exportFailed: 'Не удалось экспортировать {{what}}: {{error}}',
        documents: 'Документы',
        openInSales: 'Открыть в списке продаж',
        notFound: 'Клиент не найден. Возможно, он удалён или объединён, либо ссылка неверна.',
        back: 'Все клиенты',
        openClientPage: 'Страница клиента',
        noDocuments: 'Нет доступных вам документов по этому клиенту',
        loadMore: 'Загрузить ещё',
        sortBy: 'Сортировать: {{column}}',
      },
      docType: {
        'Sales Invoice': 'Инвойс',
        Quotation: 'Ценовое предложение',
        'Inventory expenditure order': 'Расходный ордер',
      },
      status: { Draft: 'Черновик', Issued: 'Выпущен', Void: 'Аннулирован' },
      payment: { Unpaid: 'Не оплачен', Paid: 'Оплачен', Partial: 'Частично', Cancelled: 'Отменён' },
      field: {
        createdBy: 'Создал',
        to: 'Кому',
        contact: 'Контакт',
        position: 'Должность',
        contacts: 'Контакты',
        primary: 'Основной',
        addContact: 'Добавить контакт',
        noContacts: 'Контактов пока нет',
        organization: 'Предприятие',
        registrationNo: 'Рег. номер',
        registrationNoIndividual: 'Регистрационный номер (РД)',
        clientKind: 'Тип клиента',
        clientKindCompany: 'Организация',
        clientKindIndividual: 'Физическое лицо',
        address: 'Адрес',
        phone: 'Телефон',
        email: 'Эл. почта',
        date: 'Дата',
        dueDate: 'Срок',
        currency: 'Валюта',
        purchaser: 'Получатель',
        otherTerms: 'Прочие условия',
        details: 'Детали / ссылка',
        detailsHint: 'напр. AGS - Res2D Inv',
        title: 'Название',
        type: 'Тип',
        noType: 'Префикс номера',
        requestDate: 'Дата заявки',
        total: 'Общая сумма',
        preparedBy: 'Подготовил',
        purpose: 'Цель',
        comment: 'Комментарий',
        country: 'Страна',
        city: 'Город / регион',
        startDate: 'Дата начала',
        endDate: 'Дата окончания',
        totalDays: 'Всего дней',
        amountReceived: 'Полученная сумма',
        bankName: 'Название банка',
        accountName: 'Наименование счёта',
        accountNumber: 'Номер счёта',
        department: 'Отдел',
        hotelNorm: 'Норма гостиницы',
        mealNorm: 'Норма питания',
        expenseType: 'Тип',
        paidBy: 'Оплата',
        rate: 'Курс',
        activity: 'Мероприятие',
        amount: 'Сумма',
        description: 'Описание',
        income: 'Доход',
        expense: 'Расход',
        period: 'Период',
        product: 'Продукт',
        group: 'Группа',
        subgroup: 'Подгруппа / бренд',
        licencingTool: 'Инструмент лицензирования',
        daily: 'В день',
        monthly: 'В месяц',
        quarterly: 'За 3 месяца',
        semiannual: 'За 6 месяцев',
        annual: 'В год',
        // ONE rate box. ⚠️ Still NOT `field.rate` (TripExpenses' compact column).
        // `{{unit}}` is USD, or KZT on a KZT document -- always known, since it
        // comes off the form's currency select.
        usdRate: 'Курс (₮ за 1 {{unit}})',
        usdRateHintMnt: 'Пересчитывает цены прайс-листа (USD) в ₮ при выборе. К позициям, введённым вручную, не применяется.',
        usdRateHintForeign: 'Печатает итог в ₮ под итоговой суммой. Пусто — сумма в ₮ не печатается.',
        usdRateInvalid: 'Введите положительное число (до 6 знаков после запятой) или оставьте пустым.',
        kztUsdRate: 'Курс (₸ за 1 USD)',
        kztUsdRateHint: 'Пересчитывает цены прайс-листа (USD) в ₸ при выборе. К позициям, введённым вручную, не применяется.',
        // Any ISO-4217 currency.
        currencyOther: 'Другая…',
        currencyCode: 'Код валюты (ISO 4217)',
        currencyCodeApply: 'Применить',
        currencyCodeInvalid: 'Три буквы, например EUR.',
        vatRegistrationNo: 'Номер плательщика НДС',
        issuer: 'Компания-эмитент',
        issuerAutomatic: 'Автоматически (по клиенту или основная компания)',
        issuerAutomaticNamed: 'Автоматически — {{name}}',
        issuerWillPrint: 'Будет напечатано от: {{name}}',
        issuerPrinted: 'Выставлено от: {{name}}',
        // The bank box falls back to the org default company's account.
        bankFallback: 'У {{company}} нет счёта в {{currency}} — в документе будет указан счёт {{holder}} в {{currency}}.',
        bankNone: 'У {{company}} нет счёта в {{currency}} — банковские реквизиты не будут напечатаны.',
        // The document's own bank pick and signature toggle.
        bankAccount: 'Банковский счёт',
        bankAutomatic: 'Автоматически (счёт клиента или компании)',
        // The document's own print language, independent of the app's.
        documentLanguage: 'Язык документа',
        signAs: 'Подпись',
        signAsSelf: 'От своего имени',
        signAsAccountant: '{{name}} (бухгалтер)',
        signAsNone: 'Нет бухгалтера с подписью в системе',
        newStyle: 'Новый стиль',
        newStyleHint: 'Пробный PDF в новом стиле; выпущенный файл не меняется',
        seequentContact: 'Контактное лицо Seequent',
        fslProdCode: 'Код продукта FSL',
        fslDealCode: 'Код сделки FSL',
        fslUpdate: 'Обновление FSL',
        note: 'Примечание',
        active: 'Активен',
        approval: 'Статус одобрения',
        approvedAmount: 'Утверждённая сумма',
        approvedBy: 'Утвердил',
        approved: 'Утверждено',
        adminApproved: 'Одобрено админом',
        rejectReason: 'Причина отказа',
        name: 'Имя',
        clientName: 'Название',
        accountManager: 'Менеджер клиента',
        noAccountManager: 'Не назначен',
        accountManagerLocked: 'Изменить может только текущий менеджер или администратор.',
        accountManagerUnknown: 'Бывший сотрудник',
        industry: 'Отрасль',
        tags: 'Теги',
        tagsHint: 'Через запятую.',
        clientNotes: 'Примечания',
        nickname: 'Псевдоним',
        clientNo: 'Номер клиента',
        no: 'Номер',
        status: 'Статус',
        payment: 'Оплата',
        paymentStatus: 'Статус оплаты',
        paidDate: 'Дата оплаты',
        role: 'Роль',
        access: 'Доступ',
        accessLevel: 'Уровень доступа',
        client: 'Клиент',
        defaultIssuerIdentity: 'Эмитент по умолчанию',
        defaultBankAccount: 'Банковский счёт по умолчанию',
        noDefault: '— Нет —',
        chooseIdentityFirst: 'Сначала выберите компанию-эмитента',
        bankIdentityMismatch: '(не соответствует выбранной компании)',
      },
      line: {
        basePrice: 'Базовая цена',
        customsTaxPct: 'Таможенная пошлина %',
        marginPct: 'Наценка %',
        markupInvalid: 'Введите базовую цену (до 5 знаков после запятой) и проценты (до 4 знаков) числами от 0 и выше.',
      },
      items: {
        no: '№',
        item: 'Наименование',
        unit: 'Ед',
        qty: 'Кол-во',
        unitPrice: 'Цена за ед.',
        amount: 'Общая стоимость',
        add: 'Добавить строку',
        fromPriceList: 'Из прайс-листа',
        empty: 'Строк пока нет',
        priceDecimals: 'Цена за ед. — не более 5 знаков после запятой',
        notNegative: 'Не может быть меньше 0',
        notANumber: 'Введите число',
      },
      totals: {
        // The MNT equivalent under the total.
        mntEquivalent: 'Итого в тугриках (1 {{currency}} = {{rate}} ₮)',
        subtotal: 'Итого',
        discount: 'Скидка',
        discountType: 'Тип скидки',
        discountOver100: 'Процент скидки не может превышать 100.',
        vat: 'НДС',
        rounding: 'Округление',
        total: 'Итого с НДС',
      },
      discountType: { None: 'Нет', Amount: 'Сумма', Percentage: 'Процент' },
      issue: {
        confirmTitle: 'Сохранить документ?',
        confirmBody:
          'При сохранении присваивается номер и запись фиксируется. После этого изменить её нельзя — потребуется новая версия.',
        save: 'Сохранить',
        saved: 'Сохранено',
        draftKept: 'Черновик сохранён, но документ сохранить не удалось: {{error}}',
        sendEmail: 'Подготовить письмо клиенту',
        addressSite: 'Адрес компании в этом документе',
        addressDefault: 'по умолчанию',
        site: { head_office: 'Головной офис', branch: 'Филиал' },
        locked: 'Документ выпущен и больше не редактируется.',
        lockedVoid: 'Документ аннулирован и больше не редактируется.',
        invoiceReadOnly: 'Счета-фактуры может редактировать только бухгалтер, финдиректор или админ.',
        notYourDraft: 'Этот черновик может изменять только его автор, финансовый директор, бухгалтер или админ.',
        mailDraft: 'Письмо клиенту',
        mailDraftTo: 'Письмо на {{to}}',
        mailOpenOutlook: 'Открыть в Outlook',
        mailLink: 'Ссылка для письма',
        mailNoAddress: 'В документе нет эл. почты клиента, поэтому поле «Кому» пустое.',
        mailBadAddress: '«{{typed}}» не подходит как адрес эл. почты, поэтому поле «Кому» пустое.',
        mailEmlSaved: 'Черновик скачан. Откройте файл, отредактируйте и отправьте.',
        mailPdfSaved: 'PDF скачан. Приложите его к письму перед отправкой.',
        mailOpenFailed: 'Не удалось скачать черновик письма: {{reason}}',
        mailPdfFailed: 'Не удалось скачать PDF: {{reason}}',
        mailDraftFailed: 'Не удалось подготовить письмо: {{reason}}',
        mailLinkLoading: 'Письмо ещё загружается.',
        mailLinkUnavailable: 'Не удалось подготовить письмо.',
        mailLinkTooLong: 'Письмо слишком длинное для ссылки. Используйте «Открыть в Outlook».',
      },
      void: {
        title: 'Аннулировать документ',
        reasonLabel: 'Причина',
        confirm: 'Аннулировать',
      },
      paymentRecord: {
        title: 'Платежи',
        balanceDue: 'Остаток к оплате',
        amountPaid: 'Оплачено',
        action: 'Зафиксировать платёж',
        dialogTitle: 'Зафиксировать платёж',
        amountLabel: 'Сумма',
        dateLabel: 'Дата',
        noteLabel: 'Примечание',
        submit: 'Зафиксировать',
        recorded: 'Платёж зафиксирован',
        amountInvalid: 'Сумма должна быть больше нуля',
        entryCleared: 'Отмечено как неоплачено',
        entryCancelled: 'Отменено',
      },
      list: {
        clientDocuments: 'Документы',
        empty: 'Документы не найдены',
        emptyClients: 'Клиенты не найдены',
        noChanges: 'Изменений пока нет',
        partialIsDerived: '«Частично» вычисляется из платежей: выберите «Не оплачен», «Оплачен» или «Отменён».',
        filters: 'Фильтры',
        all: 'Все',
        loadFailed: 'Не удалось загрузить «{{title}}»',
        documentLoadFailed: 'Не удалось открыть этот документ',
        saveFailed: 'Не удалось сохранить: {{reason}}',
        deleteFailed: 'Не удалось удалить: {{reason}}',
        approveFailed: 'Не удалось утвердить: {{reason}}',
        rejectFailed: 'Не удалось отклонить: {{reason}}',
        payFailed: 'Не удалось отметить как оплаченное: {{reason}}',
        downloadFailed: 'Не удалось скачать PDF: {{reason}}',
        loadedOf: 'Показано {{count}} из {{total}}',
        loadingMore: 'Загрузка…',
        loadMoreRetry: 'Повторить загрузку',
        mergeFailed: 'Не удалось объединить: {{reason}}',
        previewFailed: 'Не удалось построить предпросмотр: {{reason}}',
        issueFailed: 'Не удалось выставить документ: {{reason}}',
        reviseFailed: 'Не удалось создать новую версию: {{reason}}',
        convertFailed: 'Не удалось преобразовать в счёт: {{reason}}',
        copyFailed: 'Не удалось создать копию: {{reason}}',
        voidFailed: 'Не удалось аннулировать документ: {{reason}}',
        paymentFailed: 'Не удалось записать платёж: {{reason}}',
        pickHint: 'Выберите клиента, чтобы увидеть детали.',
        discardConfirm: 'Есть несохранённые изменения. Отменить их?',
        deleteClientConfirm: 'Удалить клиента «{{name}}»? Клиента, на которого ссылается документ, удалить нельзя.',
        // Merge another client INTO the open one, which survives.
        mergeTitle: 'Объединить другого клиента с этим',
        mergeHint: 'Документы и контакты выбранного клиента перейдут сюда, а его данные заполнят пустые поля этого клиента. Затем он будет удалён. Номера выставленных документов не меняются.',
        mergePick: 'Выберите клиента…',
        mergeSaveFirst: 'Перед объединением сохраните или отмените изменения.',
        mergeAction: 'Объединить',
        mergeConfirm: 'Объединить «{{loser}}» с «{{survivor}}»? «{{loser}}» будет удалён. Это нельзя отменить.',
        mergeDone: 'Клиенты объединены',
        mergeTakeRegNo: 'Также взять регистрационный номер {{regNo}} у «{{loser}}». Документы с этим номером продолжат ту же серию.',
      },
      requestType: { Reimbursement: 'Возмещение', Purchase: 'Закупка' },
      requestStatus: { Pending: 'Ожидает', Approved: 'Утверждено', Sent: 'Отправлено', Rejected: 'Отклонено' },
      role: {
        Finance: 'Финансы',
        Accountant: 'Бухгалтер',
        'Chief finance officer': 'Финансовый директор',
        Dev: 'Разработчик',
      },
      requests: {
        new: 'Новая заявка',
        empty: 'Заявок пока нет',
        approve: 'Утвердить',
        reject: 'Отклонить',
        approved: 'Заявка одобрена',
        rejected: 'Заявка отклонена',
        alreadyApproved: 'Уже одобрена.',
        alreadyRejected: 'Уже отклонена.',
        items: 'Позиции',
        addRow: 'Добавить строку',
        noItems: 'Позиций пока нет',
        needAmount: 'Добавьте хотя бы одну позицию с суммой.',
        details: 'Общие сведения',
        notes: 'Примечания',
        selectPrompt: 'Выберите заявку из списка или создайте новую.',
        pendingOnly: 'Только ожидающие',
        whose: 'Чьи заявки',
      },
      trips: {
        new: 'Новая командировка',
        empty: 'Командировок пока нет',
        emptyFiltered: 'Нет командировок с этим статусом',
        emptyMine: 'Среди ваших командировок совпадений нет',
        whose: 'Чьи командировки',
        approve: 'Одобрить командировку',
        approved: 'Командировка одобрена',
        markPaid: 'Отметить оплаченной',
        paid: 'Командировка отмечена оплаченной',
        already: 'Командировка уже одобрена.',
        expenses: 'Расходы',
        addExpense: 'Добавить расход',
        noExpenses: 'Расходов пока нет',
        uploadReceipt: 'Загрузить чек',
        receipt: 'Чек',
        saveTripFirst: 'Сначала сохраните командировку, чтобы добавить расходы.',
        currencyUnknown: 'Не указана',
        details: 'Детали командировки',
        norms: 'Нормы расходов',
        bankDetails: 'Банковские реквизиты',
        selectPrompt: 'Выберите командировку из списка или создайте новую.',
      },
      activityFund: {
        new: 'Новый расход',
        empty: 'Расходов пока нет',
        items: 'Мероприятия',
        addRow: 'Добавить строку',
        noItems: 'Строк пока нет',
        thisMonth: 'Этот месяц',
        fundBalance: 'Остаток фонда',
        selectPrompt: 'Выберите мероприятие из списка или создайте новое.',
        contributionsTitle: 'Ежемесячные взносы',
        extraIncomeTitle: 'Дополнительный доход',
        extraIncomeHint: 'Деньги в фонд вне ежемесячных взносов, например штрафы или пожертвования. Баллы активности за них не начисляются.',
        addExtraIncome: 'Добавить доход',
        extraIncomePerson: 'Сотрудник',
        extraIncomeNoPerson: 'Без сотрудника',
        extraIncomeReason: 'Причина',
        extraIncomeRecordedBy: 'Записал',
        noExtraIncome: 'Дополнительного дохода пока нет',
        extraIncomeInvalid: 'Укажите дату и сумму больше нуля.',
        expensesTitle: 'Расходы',
        gridHint: 'Нажмите на месяц, чтобы отметить оплату.',
        settings: 'Настройки',
        previousYear: 'Предыдущий год',
        nextYear: 'Следующий год',
        markPaid: 'Отметить выплаченным',
        noContributors: 'Нет сотрудников',
        points: 'Баллы',
        offRoster: 'Вне штата',
        windowNotice: 'Этот месяц нельзя редактировать.',
        readOnlyNotice: 'У вас нет прав на редактирование.',
        notYoursNotice: 'Изменить этот расход может только тот, кто его внёс, или администратор.',
        raisedBy: 'Внёс',
        contributorsOnlyNotice:
          'Список ежемесячных взносов виден тем, кто платит в фонд.',
        saveChanges: 'Сохранить',
        discardChanges: 'Отменить',
        unsavedChanges: 'Несохранённых изменений: {{count}}',
        finishBeforeYearChange: 'Сохраните или отмените изменения перед сменой года.',
        fundAmount: 'Взнос и бонус за балл',
        fundAmountHint: 'Одна сумма: взнос за вновь отмечаемый месяц и бонус за каждый балл активности в расчёте, отмеченном для выплаты фонда за прошлый год. Уже отмеченные месяцы сохраняют свои суммы; ещё не выпущенные расчёты используют новую сумму.',
        addPerson: 'Добавить человека…',
        notSavedYet: 'Не сохранено',
        notEligible: '{{name}} не может вступить в фонд активности: только штатные сотрудники и подрядчики с почасовой оплатой',
        notEligibleNobody: 'В фонд активности могут вступить только штатные сотрудники и подрядчики с почасовой оплатой',
        setAmountFirst: 'Сумма фонда равна 0: задайте сумму, прежде чем отмечать месяц',
        leftOn: 'Уволен(а): {{date}}',
      },
      // "Set the final total": one line's unit price reaches a target total.
      targetTotal: {
        action: 'Задать итог…',
        title: 'Задать итоговую сумму',
        intro: 'Введите нужный итог и выберите ОДНУ строку, цена которой изменится. Ничего не сохранится, пока вы не нажмёте «Сохранить».',
        current: 'Текущий итог',
        targetLabel: 'Целевой итог',
        invalid: 'Введите сумму больше 0, не более 2 знаков после запятой.',
        untitledLine: 'Строка без названия',
        qty: 'кол-во {{qty}}',
        unreachable: 'Ни одна цена этой строки не даёт ровно {{target}}. Ближайшие итоги:',
        below: 'Ниже',
        above: 'Выше',
        belowMinimum: 'Даже при цене 0 в этой строке итог больше {{target}}.',
        aboveMaximum: 'Ни одна цена этой строки не достигает {{target}}.',
        noEffect: 'Количество 0, поэтому цена этой строки не влияет на итог.',
        done: 'Цена строки {{line}} установлена: {{price}} — проверьте и сохраните.',
      },
      // See the English block for why counts are not `{{count}}`.
      // "Convert this DRAFT to USD": every line price and an amount
      // discount divided by the rate. Drafts only; nothing saves until Save.
      convertUsd: {
        action: 'Перевести этот черновик в USD',
        warning: 'Цена каждой позиции и скидка суммой будут разделены на {{rate}}, а валюта документа станет USD. Ничего не сохранится, пока вы не нажмёте «Сохранить».',
        confirm: 'Перевести',
        done: 'Позиций переведено в USD: {{lines}} — проверьте и сохраните.',
      },
      reapply: {
        action: 'Пересчитать по курсу',
        loading: 'Загрузка прайс-листа…',
        title: 'Пересчитать по курсу валюты',
        warning:
          'Это ПЕРЕЗАПИШЕТ цену каждой отмеченной строки, пересчитав её цену из прайс-листа по курсу {{rate}} в {{currency}}. Неотмеченные строки сохранят текущую цену.',
        currentPrice: 'Текущая',
        newPrice: 'Новая',
        untitledLine: 'Строка без названия',
        unchanged: 'Уже по этому курсу.',
        selectedCount: 'Выбрано {{selected}} из {{total}} строк',
        blockedCount: '{{blocked}} нельзя пересчитать',
        confirm: 'Пересчитать выбранные',
        done: 'Курс применён к {{applied}} строкам',
        applied: 'Курс {{rate}} применён {{at}}',
        notRecorded: 'Применённый курс: не записан',
        block: {
          'not-from-price-list': 'Введено вручную — нет цены из прайс-листа для пересчёта.',
          'item-not-found': 'Позиция прайс-листа больше не существует.',
          // Re-apply converts USD list prices only.
          'item-currency': 'Цена этой позиции не в USD, поэтому курс к ней не применяется.',
          'unit-not-a-tier':
            'Единица измерения не соответствует уровню прайс-листа, поэтому неизвестно, из какой цены она взята.',
          'no-price-for-tier': 'В прайс-листе нет цены для этого уровня.',
        },
      },
      // Download asks whether the signature goes on the PDF.
      pdfSignature: {
        title: 'Скачать PDF',
        body: 'Поставить подпись на PDF?',
        include: 'С подписью',
        omit: 'Без подписи',
        notSigner: 'Документ выпущен без подписи. Добавить свою подпись может только подписант.',
        addToContinue: 'У вас нет подписи. Добавьте её, и скачивание продолжится.',
        stillNone: 'Подпись не добавлена, поэтому файл не скачан.',
      },
      lineage: {
        converted: 'Преобразовано из {{no}}',
        revised: 'Новая версия документа {{no}}',
        copied: 'Скопировано из {{no}}',
        unknown: 'Из {{no}}',
        untitled: 'более ранний черновик',
        copyDone: 'Копия создана',
        copyAction: 'Создать копию',
        copyNotLinked: 'Эта копия не связана с документом, из которого она создана.',
        copySaveFirst: 'Сохраните изменения перед копированием.',
        copyHint: 'Создать новый, отдельный документ на основе этого. Этот документ не изменится.',
        reviseAction: 'Новая версия',
        reviseHint: 'Создать новую версию, которая заменит эту. После сохранения новой версии эта будет аннулирована как заменённая.',
        reviseDone: 'Черновик новой версии создан',
        reviseSuperseded: 'Эта версия уже заменена. Откройте последнюю версию, чтобы её изменить.',
        supersededShort: 'Заменена',
        versionsTitle: 'Версии',
        quotationReplaced: 'У этого коммерческого предложения уже есть действующая редакция или счёт. Сначала аннулируйте или удалите его.',
      },
      // `draft` is for a replacement with no number yet -- never invent one.
      replaced: {
        numbered: 'Заменён документом #{{no}}',
        draft: 'Заменён черновиком',
      },
      priceList: {
        new: 'Новая позиция',
        edit: 'Изменить позицию',
        productRequired: 'Введите название продукта.',
        empty: 'Позиций пока нет',
        selectPrompt: 'Выберите позицию из списка или создайте новую.',
        sectionProduct: 'Продукт и классификация',
        sectionPricing: 'Цены',
        sectionCodes: 'Коды и примечание',
        pickOrType: 'Выберите или введите новое',
        percentLabel: '% от годовой',
        percentNeedsAnnual: 'Укажите годовую цену, чтобы вводить проценты.',
        lineCount: 'Позиций: {{count}}',
        // The grouped table's chevrons, and the picker's tunnel filters.
        expandAll: 'Развернуть всё',
        collapseAll: 'Свернуть всё',
        expand: 'Развернуть {{name}}',
        collapse: 'Свернуть {{name}}',
        // The picker's custom tax % and margin %.
        customTaxPct: 'Таможенная пошлина %',
        marginPct: 'Наценка %',
        markupInvalid: 'Введите проценты числом от 0 и выше.',
        unnamed: '(нет)',
        filterAny: 'Все',
        addUnder: 'Добавить позицию в “{{product}}”',
        rateApplied: 'Цены прайс-листа (USD) ниже пересчитаны по курсу {{rate}} ₮ за 1 USD в {{currency}}.',
        rateInvalid: 'Введите курс (₮ за 1 USD), чтобы перенести цены прайс-листа (USD) в этот документ.',
        rateKztNeeded: 'Введите курс (₸ за 1 USD), чтобы перенести цены прайс-листа (USD) в этот документ.',
        rateAppliedKzt: 'Цены прайс-листа (USD) ниже пересчитаны по курсу {{rate}} ₸ за 1 USD в KZT.',
        // A non-USD item the document's one rate cannot convert.
        itemCurrencyRefused: 'Цена в {{item}} — нельзя добавить в документ в {{currency}}.',
        rateChange: 'Изменить курс',
        rateChangeApply: 'Применить',
        rateAskInline: 'Курс не задан, поэтому цены ниже показаны в валюте прайс-листа. При выборе цены будет запрошен курс.',
        askRate: '1 {{from}} =',
        askRateAdd: 'Добавить',
        semiannualHint: 'Вводится вручную — не вычисляется из годовой цены.',
      },
  },
}
